// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"IntroText_subtitle__3v3TA","title":"IntroText_title__hrV0f","paragraph":"IntroText_paragraph__35VdA","extra":"IntroText_extra__OAgaF","image":"IntroText_image__1IFsf"};